(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["betta-fish-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'tfBettaContentV6Blocks';
  if (window[key]) { window[key].scan(document); return; }
  const initialized = new WeakSet();
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const tabs = [...root.querySelectorAll('[data-care]')];
    const panels = [...root.querySelectorAll('.tf-tabpanel')];
    function selectTab(tab, focus = false) {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => {
        const active = panel.id === tab.getAttribute('aria-controls');
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
      });
    });
    if (tabs.length) {
      selectTab(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      root.dataset.tfTabsReady = 'true';
    }
    root.dataset.tfReady = 'true';

    const tracks = [...root.querySelectorAll('[data-scroll-track]')];
    function updateTrack(track) {
      const arrows = [...root.querySelectorAll('[data-scroll-target]')].filter(button => button.dataset.scrollTarget === track.id);
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      arrows.forEach(button => button.disabled = Number(button.dataset.scrollDirection) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
    }
    root.querySelectorAll('[data-scroll-target]').forEach(button => button.addEventListener('click', () => {
      const track = tracks.find(item => item.id === button.dataset.scrollTarget);
      if (!track) return;
      const child = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).gap) || 20;
      const distance = child ? child.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left: distance * Number(button.dataset.scrollDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    tracks.forEach(track => {
      track.addEventListener('scroll', () => updateTrack(track), {passive: true});
      track.querySelectorAll('img').forEach(image => image.addEventListener('load', () => updateTrack(track), {once: true}));
      updateTrack(track);
    });
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => tracks.forEach(updateTrack)) : null;
    if (resize) tracks.forEach(track => resize.observe(track));
    root.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => tracks.forEach(updateTrack)));

    root.querySelectorAll('[data-tf-product]').forEach(card => {
      const select = card.querySelector('[data-tf-variant]');
      if (!select) return;
      const form = card.querySelector('form');
      const button = card.querySelector('button[name="add"]');
      const feedback = card.querySelector('[data-tf-cart-feedback]');
      const viewCart = card.querySelector('[data-tf-cart-view]');
      let adding = false;
      const update = () => {
        const option = select.options[select.selectedIndex];
        const available = option?.dataset.available === 'true';
        const price = card.querySelector('[data-tf-price]');
        const quantity = card.querySelector('[name="quantity"]');
        const notice = card.querySelector('[data-tf-quantity-note]');
        const min = Number(option?.dataset.quantityMin) || 1;
        if (price && option) price.textContent = option.dataset.price;
        if (quantity) quantity.value = min;
        if (notice) { notice.hidden = min <= 1; notice.textContent = 'Adds ' + min + ' of the selected option (minimum quantity).'; }
        if (button) { button.disabled = adding || !available; button.textContent = adding ? 'Adding…' : available ? 'Add to cart' : 'Sold out'; }
      };
      select.addEventListener('change', () => {
        if (feedback) { feedback.textContent = ''; feedback.removeAttribute('data-error'); }
        if (viewCart) viewCart.hidden = true;
        update();
      });
      update();
      if (!form || !button || !feedback) return;
      // Capture this form's submission before theme handlers can submit it again.
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (adding || select.options[select.selectedIndex]?.dataset.available !== 'true') return;
        const body = new FormData(form);
        body.delete('return_to');
        const addUrl = new URL(form.action, location.href);
        addUrl.pathname = addUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
        const badge = document.getElementById('cart-icon-bubble');
        if (badge) {
          body.set('sections', 'cart-icon-bubble');
          body.set('sections_url', location.pathname);
        }
        const wasDisabled = select.disabled;
        adding = true;
        select.disabled = true;
        form.setAttribute('aria-busy', 'true');
        feedback.textContent = '';
        feedback.removeAttribute('data-error');
        if (viewCart) viewCart.hidden = true;
        update();
        try {
          const response = await fetch(addUrl.href, {
            method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body
          });
          const result = await response.json().catch(() => null);
          if (!response.ok || Number(result?.status) >= 400) {
            const message = typeof result?.description === 'string' ? result.description : typeof result?.message === 'string' ? result.message : 'Unable to add this item. Please check your cart and try again.';
            throw new Error(message);
          }
          if (!result || (!result.id && !Array.isArray(result.items))) {
            throw new Error('We could not confirm the cart update. Check your cart before trying again.');
          }
          feedback.textContent = 'Added to cart. Keep exploring!';
          // Refresh supported theme cart badges without opening a drawer or changing pages.
          if (badge && typeof result.sections?.['cart-icon-bubble'] === 'string') {
            const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
            const freshBadge = parsed.getElementById('cart-icon-bubble') || parsed.querySelector('.shopify-section');
            if (freshBadge) badge.innerHTML = freshBadge.innerHTML;
          }
          card.dispatchEvent(new CustomEvent('tf:cart-added', {bubbles: true, detail: {item: result}}));
        } catch (error) {
          feedback.dataset.error = 'true';
          feedback.textContent = error instanceof TypeError ? 'We could not confirm the cart update. Check your cart before trying again.' : error.message || 'Unable to add this item. Please check your cart and try again.';
        } finally {
          adding = false;
          select.disabled = wasDisabled;
          form.removeAttribute('aria-busy');
          if (viewCart) viewCart.hidden = false;
          update();
        }
      }, true);
    });
    root.querySelectorAll('video').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.play().catch(() => {});
    });
    root.tfCleanup = () => resize?.disconnect();
  }
  function reveal(target, scroll) {
    const root = target.closest('[data-tf-betta-content]');
    if (!root) return;
    let ancestor = target;
    while (ancestor && ancestor !== root) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    const panel = target.closest('.tf-tabpanel');
    if (panel) root.querySelector('[aria-controls="' + panel.id + '"]')?.click();
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block: 'start', behavior: 'auto'}));
  }
  function fromHash(scroll = true) {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (id) { const target = document.getElementById(id); if (target) reveal(target, scroll); }
  }
  function scan(scope) {
    if (scope.matches?.('[data-tf-betta-content]')) init(scope);
    scope.querySelectorAll('[data-tf-betta-content]').forEach(init);
  }
  window[key] = {scan};
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
    if (!target?.closest('[data-tf-betta-content]')) return;
    event.preventDefault();
    const root = target.closest('[data-tf-betta-content]');
    if (link.dataset.careJump) root.querySelector('[data-care="' + link.dataset.careJump + '"]')?.click();
    history.replaceState(null, '', url.hash);
    reveal(target, true);
  });
  window.addEventListener('hashchange', () => fromHash());
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest?.('[data-tf-setup-block]');
    if (!card) return;
    card.scrollIntoView({block:'nearest', inline:'center', behavior:'auto'});
  });
  document.addEventListener('shopify:section:load', event => { scan(event.target); fromHash(false); });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tf-betta-content]').forEach(root => root.tfCleanup?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { scan(document); fromHash(); }, {once: true});
  else { scan(document); fromHash(); }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-order-tracking"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hub = document.querySelector('[data-tf-hub]');
  const mount = document.getElementById('pp-tracking-page-app');
  if (!hub || !mount || mount.dataset.tfInitialized) return;
  mount.dataset.tfInitialized = 'true';
  const improveSemantics = () => {
    const title = mount.querySelector('.pp_tracking_title');
    if (title) title.setAttribute('aria-hidden', 'true');
    mount.querySelectorAll('h1:not(.pp_tracking_title)').forEach(heading => {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
    const hints = {order: hub.dataset.orderPlaceholder, email: hub.dataset.emailPlaceholder, nums: hub.dataset.trackingPlaceholder};
    mount.querySelectorAll('input').forEach(input => {
      if (hints[input.name] && !input.placeholder) input.placeholder = hints[input.name];
    });
    if (mount.querySelector('form')) {
      const loading = hub.querySelector('[data-tf-loading]');
      if (loading) loading.hidden = true;
    }
  };
  const observer = new MutationObserver(improveSemantics);
  observer.observe(mount, {childList: true, subtree: true});
  improveSemantics();
  const source = 'https://pp-proxy.parcelpanel.com/assets/tracking/track-page.js';
  if (!document.querySelector('script[src*="pp-proxy.parcelpanel.com/assets/tracking/track-page.js"]')) {
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.addEventListener('error', () => {
      const loading = hub.querySelector('[data-tf-loading]');
      if (loading) loading.hidden = true;
    });
    document.head.append(script);
  }
  window.setTimeout(() => {
    const loading = hub.querySelector('[data-tf-loading]');
    if (loading) loading.hidden = true;
  }, 15000);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(hub)) observer.disconnect();
  });
})();

if (!customElements.get('tf-packaging-tabs')) {
  customElements.define('tf-packaging-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-pack-panel]'));
      this.tablist = this.querySelector('[role="tablist"]');
      this.media = matchMedia('(max-width: 749px)');
      this.selected = 0;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let index = this.selected;
          if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(index);
          this.tabs[index].focus();
        }, options);
      });
      this.media.addEventListener('change', () => this.update(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
      this.update();
    }
    select(index) { this.selected = index; this.update(); }
    update() {
      const compact = this.media.matches && this.tabs.length > 1;
      this.tablist.hidden = !compact;
      this.tabs.forEach((tab, index) => {
        const active = index === this.selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.panels[index];
        panel.hidden = compact && !active;
        if (compact) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('tabindex');
          panel.setAttribute('aria-labelledby', panel.querySelector('h3').id);
        }
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

if (!customElements.get('tf-shipping-upgrade')) {
  customElements.define('tf-shipping-upgrade', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.busy = false;
      this.scope = this.closest('[data-tf-hub]') || document;
      this.scope.querySelectorAll('[data-tf-upgrade-open]').forEach(button => button.addEventListener('click', () => {
        this.opener = button;
        if (this.busy) this.dialog.show();
        else this.dialog.showModal();
        this.querySelector('[data-tf-upgrade-result], input:not([type="hidden"])')?.focus();
      }, options));
      this.querySelectorAll('[data-tf-upgrade-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('close', () => { if (!this.busy) this.opener?.focus(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.form?.addEventListener('change', () => this.updateCost(), options);
      this.form?.addEventListener('submit', event => {
        if (this.busy) { event.preventDefault(); return; }
        if (!this.form.reportValidity()) { event.preventDefault(); return; }
        this.updateCost();
        if (this.form.hasAttribute('data-tf-local-preview')) {
          event.preventDefault();
          this.showError(this.querySelector('[data-tf-upgrade-preview-message]').textContent);
          return;
        }
        if (!navigator.onLine) {
          event.preventDefault();
          this.showError(this.querySelector('[data-tf-upgrade-offline]').textContent);
          return;
        }
        event.preventDefault();
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.submitButton.dataset.busyLabel;
        this.querySelector('[data-tf-upgrade-status]').textContent = this.submitButton.dataset.busyLabel;
        this.timer = setTimeout(() => {
          this.showError(this.querySelector('[data-tf-upgrade-unconfirmed]').textContent);
        }, 45000);
        // Use Shopify's supported CAPTCHA integration before the native POST.
        // Its callback may arrive after the initial submit event has finished.
        let submitted = false;
        const send = () => {
          if (submitted || !this.isConnected) return;
          submitted = true;
          this.form.submit();
        };
        if (window.Shopify?.captcha?.protect) {
          // A modal dialog makes Shopify's body-mounted CAPTCHA inert and hides it
          // beneath the browser top layer. Keep the form visible as a non-modal
          // dialog while Shopify owns verification; never move or bypass CAPTCHA.
          this.dialog.classList.add('tf-upgrade-verifying');
          this.dialog.close();
          this.dialog.show();
          window.Shopify.captcha.protect(this.form, send);
        }
        else send();
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted && this.submitButton) {
          this.busy = false;
          this.dialog.classList.remove('tf-upgrade-verifying');
          this.form.removeAttribute('aria-busy');
          this.submitButton.disabled = false;
          this.submitButton.textContent = this.submitButton.dataset.idleLabel;
          this.querySelector('[data-tf-upgrade-status]').textContent = '';
          clearTimeout(this.timer);
        }
      }, options);
      const result = this.querySelector('[data-tf-upgrade-result]');
      if (result || location.hash === '#tf-upgrade-dialog') {
        this.dialog.showModal();
        (result || this.querySelector('input:not([type="hidden"])'))?.focus();
      }
      this.updateCost();
    }
    updateCost() {
      const chosen = this.querySelector('input[type="radio"]:checked');
      if (!chosen) return;
      this.querySelector('[data-tf-upgrade-total]').textContent = '+$' + chosen.dataset.cost + ' USD';
      this.querySelector('[data-tf-upgrade-cost]').value = chosen.dataset.cost;
    }
    showError(message) {
      const error = this.querySelector('[data-tf-upgrade-client-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
      error.focus();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
  });
}

(() => {
  const page = document.querySelector('.tf-tracking-page');
  const nav = page?.querySelector('[data-tf-page-nav]');
  if (!nav || nav.dataset.tfNavReady) return;
  nav.dataset.tfNavReady = 'true';
  const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  const rail = nav.querySelector('.tf-page-nav__links');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sections = [];
  let headers = [];
  let frame = 0;
  let pending = null;
  let userMoved = false;
  let initialAnchor = null;
  let activeId = null;
  let revealAfterResize = false;
  const revealLink = (link,smooth = true) => {
    if (!rail || rail.scrollWidth <= rail.clientWidth + 1 || !link) return;
    const bounds = rail.getBoundingClientRect();
    const item = link.getBoundingClientRect();
    const left = bounds.left + 8;
    const right = bounds.right - 8;
    const delta = item.left < left ? item.left - left : item.right > right ? item.right - right : 0;
    if (Math.abs(delta) > 1) rail.scrollTo({left:rail.scrollLeft + delta,behavior:smooth && !reduced.matches ? 'smooth' : 'instant'});
  };
  const setActive = id => {
    const changed = activeId !== id;
    activeId = id;
    links.forEach(link => {
      if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    if (changed || revealAfterResize) revealLink(links.find(link => link.hash === '#' + id),!revealAfterResize);
    revealAfterResize = false;
  };
  const headerOffset = () => {
    let bottom = 0;
    const bounds = headers.map(element => ({element, rect:element.getBoundingClientRect()}));
    bounds.sort((a,b) => a.rect.top - b.rect.top).forEach(({element,rect}) => {
      const style = getComputedStyle(element);
      if (['fixed','sticky'].includes(style.position) && style.visibility !== 'hidden' && rect.width > 0 && rect.bottom > 0 && rect.top <= bottom + 1) bottom = Math.max(bottom,rect.bottom);
    });
    return Math.max(0,Math.round(bottom));
  };
  const measure = () => {
    const offset = headerOffset();
    page.style.setProperty('--tf-nav-header-offset', offset + 'px');
    const clearance = offset + nav.getBoundingClientRect().height + 16;
    page.style.setProperty('--tf-nav-scroll-offset', clearance + 'px');
    return clearance;
  };
  const targetTop = (target,clearance) => Math.max(0,Math.min(window.scrollY + target.getBoundingClientRect().top - clearance,document.documentElement.scrollHeight - window.innerHeight));
  const refresh = () => {
    sections = links.map(link => page.querySelector(link.hash)).filter(Boolean);
    headers = Array.from(document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group *, #shopify-section-header, #shopify-section-header *, sticky-header, [data-tf-sticky-header]')).filter(element => ['fixed','sticky'].includes(getComputedStyle(element).position));
    schedule();
  };
  const update = () => {
    frame = 0;
    const clearance = measure();
    if (!userMoved && initialAnchor && performance.now() < initialAnchor.until) {
      const top = targetTop(initialAnchor.target,clearance);
      if (Math.abs(window.scrollY - top) > 2) window.scrollTo({top,behavior:'instant'});
      setActive(initialAnchor.target.id);
      return;
    }
    if (pending) {
      if (Math.abs(window.scrollY - targetTop(pending.target,clearance)) > 2 && performance.now() < pending.until) {schedule();return;}
      pending = null;
    }
    let active = sections[0];
    for (const section of sections) {
      if (section.getBoundingClientRect().top <= clearance + 32) active = section;
    }
    if (active) setActive(active.id);
  };
  function schedule() {if (!frame) frame = requestAnimationFrame(update);}
  const navigate = (target,smooth,focus) => {
    const clearance = measure();
    const top = targetTop(target,clearance);
    if (focus) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }
    setActive(target.id);
    pending = {target,until:performance.now() + 1800};
    window.scrollTo({top,behavior:smooth && !reduced.matches ? 'smooth' : 'instant'});
    schedule();
  };
  nav.addEventListener('click',event => {
    const link = event.target.closest('a[href^="#"]');
    if (!links.includes(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = page.querySelector(link.hash);
    if (!target) return;
    event.preventDefault();
    userMoved = true;
    if (window.location.hash !== link.hash) history.pushState(null,'',link.hash);
    navigate(target,true,true);
  });
  nav.addEventListener('keydown',event => {
    const index = links.indexOf(event.target);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % links.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + links.length) % links.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = links.length - 1;
    if (next === undefined) return;
    event.preventDefault();links[next].focus({preventScroll:true});revealLink(links[next],false);
  });
  nav.addEventListener('focusin',event => {
    if (links.includes(event.target)) revealLink(event.target,false);
  });
  const restoreHash = () => {
    const link = links.find(item => item.hash === window.location.hash);
    const target = link && page.querySelector(link.hash);
    if (target) {
      if (!userMoved) initialAnchor = {target,until:performance.now() + 4000};
      navigate(target,false,false);
    }
    else {pending = null;schedule();}
  };
  window.addEventListener('hashchange',restoreHash);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',() => {revealAfterResize = true;schedule();},{passive:true});
  const interrupt = () => {userMoved = true;pending = null;schedule();};
  window.addEventListener('wheel',interrupt,{passive:true});
  window.addEventListener('touchstart',interrupt,{passive:true});
  window.addEventListener('pointerdown',interrupt,{passive:true});
  window.addEventListener('keydown',event => {
    if (nav.contains(event.target)) userMoved = true;
    else interrupt();
  });
  page.addEventListener('keydown',event => {
    if (['PageUp','PageDown','ArrowUp','ArrowDown','Home','End',' '].includes(event.key) && !nav.contains(event.target)) interrupt();
  });
  const resize = new ResizeObserver(schedule);
  resize.observe(nav);
  const hub = page.querySelector('[data-tf-hub]');
  if (hub) resize.observe(hub);
  document.addEventListener('shopify:section:load',refresh);
  refresh();
  restoreHash();
  window.addEventListener('load',() => {if (!userMoved) restoreHash();},{once:true});
  document.fonts?.ready.then(() => {if (!userMoved) restoreHash();});
})();


  } catch(e) { console.error(e); }
})();
})();
